function buildWhatsAppMessage(title, url, variant) {
  const lines = [
    'Bonjour Exception 👋',
    '',
    'Je souhaite commander ou avoir plus d\'infos :',
    '',
    `Produit : ${title}`,
  ];

  if (variant && variant.title && variant.title !== 'Default Title') {
    const options = [variant.option1, variant.option2, variant.option3].filter(Boolean);
    if (options[0]) lines.push(`Taille : ${options[0]}`);
    if (options[1]) lines.push(`Couleur : ${options[1]}`);
    if (options[2]) lines.push(`Option : ${options[2]}`);
  } else {
    lines.push('Taille : ');
    lines.push('Couleur : ');
  }

  lines.push(`Lien : ${url}`, '', 'Merci !');
  return lines.join('\n');
}

function getSelectedVariant() {
  const script = document.querySelector('[data-selected-variant]');
  if (!script) return null;
  try {
    return JSON.parse(script.textContent);
  } catch (_) {
    return null;
  }
}

function updateWhatsAppLink() {
  const btn = document.querySelector('[data-whatsapp-float][data-is-product]');
  if (!btn) return;

  const base = btn.dataset.waBase;
  const title = btn.dataset.productTitle;
  const url = btn.dataset.productUrl;
  const variant = getSelectedVariant();

  btn.href = `${base}?text=${encodeURIComponent(buildWhatsAppMessage(title, url, variant))}`;
}

document.addEventListener('DOMContentLoaded', () => {
  updateWhatsAppLink();

  document.querySelectorAll('variant-radios, variant-selects').forEach((root) => {
    root.addEventListener('change', () => {
      window.setTimeout(updateWhatsAppLink, 0);
    });
  });
});
